import { render, staticRenderFns } from "./AddBusinessAccount.vue?vue&type=template&id=557b3968&"
import script from "./AddBusinessAccount.vue?vue&type=script&lang=js&"
export * from "./AddBusinessAccount.vue?vue&type=script&lang=js&"
import style0 from "./AddBusinessAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports